import React from 'react';
import {AppHelmet, AppWrapper, baseUrl, baseRealtyUrl, baseRealEstateUrl, getUrlWithUtmQueryString } from '@capcenter/shared';
import {
  GlobalIcons,
  ImageCapCenterHQ,
  ImageSmores2,
  ImageSmores,
  ImageGlenAllenVA,
  ImageGlenAllenVA2,
  ImageGlenAllenVAPieDay,
  ImageGlenAllenVAPieDay2,
  ImageGlenAllenVAPieDay3,
  ImageGlenAllenVAPieDay4,
  ImageGlenAllenVAHalloweenTeam,
  ImageGlenAllenVAHalloween,
  ImageRichmondRaceway
} from '@capcenter/shared-legacy';
import {ImageGlenAllenOffice} from '@capcenter/shared-service-map';
import './Locations.scss';
import buildListingURL from '../Utilities/BuildURLString';
import getElasticSearchListings from '../Utilities/GetElasticSearchListings';


GlobalIcons();

function State(
  props: any
) {
  const [renderedHtmlListings, setRenderedHtmlListings] = React.useState<Array<any>>([]);
  const [initialized, setInitialized] = React.useState<boolean>(false);
  let htmlListings: any = [];

  async function getListings(state: string) {
    const response = await getElasticSearchListings({isRealty: props.custom.isRealty, state: state});
    return response.json();
  };

  function buildListingLinkText(listingSource: any) {
    const addressLineOne = listingSource?.UnparsedAddress?.replace(/#/g, 'Unit ');
    const city = listingSource?.City;
    const stateOrProvince = listingSource?.StateOrProvince;
    const postalCode = listingSource?.PostalCode;

    let propertyAddress = `${addressLineOne}, ${city}, ${stateOrProvince} ${postalCode}`;

    if (listingSource?.isCapcenterListing) {
      propertyAddress += " (CapCenter Listing)";
    }

    return propertyAddress;
  }

  async function renderListings() {
    const listingResponse = await getListings(props.custom.state);
    const listings = listingResponse.hits.hits;

    for (let i = 0; i < listings.length; i++) {

      let listItem =
        <li key={i}>
          <a href={getUrlWithUtmQueryString(buildListingURL(listings[i]._source))} target='_blank' rel='noreferrer noopener'>
            {buildListingLinkText(listings[i]._source)}
          </a>
        </li>;

      htmlListings.push(listItem);
    }

    setRenderedHtmlListings(htmlListings);
  }

  if (!initialized) {
    setInitialized(true);
    renderListings();
  }

  return (
    <React.Fragment>
      {(
        <AppWrapper>
          <>
            <AppHelmet
              custom={props.custom}
            />

            <div role="document">
              <main className={"locations container pb-4 " + (props.custom.code)} role="main">
                <article>
                  <header>
                    <div className={(props.custom.code)}>
                      <div className={"col-12" + (props.custom.code)}>
                        <h1>{props.custom.title}</h1>
                        <p>{props.custom.description}</p>
                      </div>
                    </div>
                  </header>

                  <section className={(props.custom.code)}>
                    <div className="row">
                      <div className="col-12 col-md-4">
                        <h3>Address</h3>
                        <p>
                          <a href="https://goo.gl/maps/yD6wUNqCnUP75RYj8" title="CapCenter HQ in Glen Allen, VA" target="_blank" rel="noreferrer noopener">
                            4461 Cox Road
                            <br />
                            Glen Allen, VA 23060
                          </a>
                        </p>
                      </div>
                      <div className="col-12 col-md-4">
                        <h3>Contact</h3>
                        <p>
                          <a href="tel:8049685000">
                            +1 (804) 968-5000
                          </a>
                          <br />
                          <a href="mailto:customerservice@capcenter.com">
                            customerservice@capcenter.com
                          </a>
                        </p>
                      </div>
                      <div className="col-12 col-md-4">
                        <h3>Hours</h3>
                        <p>
                          By appointment only
                        </p>
                      </div>
                    </div>
                  </section>

                  <section className={(props.custom.code)}>
                    <div className="row">
                      <div className="col-12">
                        <h2>About CapCenter Mortgage in {props.custom.stateLongName}</h2>
                      </div>

                      <div className="col-12 col-md-8">
                        <p>
                          Florida is a state in the Eastern and Southeastern regions of the United States with a population of 21,538,187 in 2021. Florida is one of the best places to live in the United States of America because of its beaches and coastal lifestyle.
                          The capital of Florida is Tallahassee.
                          CapCenter is proud to serve Florida and its residents to make home ownership more affordable.
                        </p>

                        <p>
                          Florida is one of the best places to live and work because of its proximity to shops, restaurants, parks, and businesses. CapCenter supports
                          Miami, South Beach, Coral Gables, Brickell, Pinecrest, Old Northeast, Historic Kenwood, College Park, Thornton Park,
                          Wynwood, Little Havana, Midtown, Coconut Grove, Key Biscayne, Pinecrest,
                          Orlando, Thorton Park, Winter Park, Mills 50, Conway, Baldwin Park, Delaney Park, Azalea Park, Doctor Phillips,
                          Tampa, Hyde Park, Ybor City, Channelside, SoHo, Westshore, South Tampa, Seminole Heights, New Tampa, Carrollwood,
                          Tallahassee, Midtown, Betton Hills, Killearn, The Meadows, The Glen at Golden Eagle, SouthWood, Bull Run, Mission Road,
                          Indianhead Acres,
                          Jacksonville, Riverside, San Marco, Avondale, Murray Hill, Springfield, Ortega, Mandarin, Riverside Park, Deerwood,
                          Naples, Fort Myers, Florida City,
                          Fort Lauderdale, Wilton Manors, Victoria Park, Colee Hammock, Poinsettia Heights, Las Olas Isles, Coral Ridge, Sunland Park,
                          Harbor Beach, Oakland Park,
                          Sarasota, St. Petersburg, St. Augustine, Lido Key, St. Armands, Longboat Key, Gulf Gate, Indian Beach/Sapphire Shores, Southgate,
                          Southside Village, Hudson Bayou, Siesta Key,
                          Destin, Pensacola, Gainesville, Cape Coral, Clearwater,
                          Boca Raton,
                          Royal Palm Yacht & Country Club, Mizner Park, Old Floresta, Woodfield Country Club, Boca Del Mar, Broken Sound,
                          Boca Pointe, Boca West, Camino Gardens,
                          West Palm Beach, Daytona Beach, Miami Beach, Kissimmee, Ocala,
                          Bradenton, Panama City, Lakeland, The Villages, Port Charlotte, Punta Gorda, Marco Island,
                          Palm Beach,
                          North End, Midtown, South End, Estate Section, Phipps Estates, The Breakers, Palm Beach Polo, Palm Beach Farms, Lake Clarke Shores,
                          Panama City Beach, Port St. Lucie, Vero Beach,
                          Cocoa Beach, North Port, Delray Beach, Bonita Springs, Winter Haven, Pompano Beach, Fort Myers Beach, Sanibel, Fort Walton Beach, Siesta Key,
                          Boynton Beach, New Smyrna Beach, St. Pete Beach, Cape Canaveral, Palm Coast, Lake Worth, Hialeah,
                          and more.
                        </p>

                        <p>See homes in
                          &nbsp;<a href={`${baseRealEstateUrl}/homes/location/city/miami-fl`} target="_blank" rel="noreferrer noopener">Miami, FL</a>,&nbsp;
                          <a href={`${baseRealEstateUrl}/homes/location/city/orlando-fl`} target="_blank" rel="noreferrer noopener">Orlando, FL</a>,&nbsp;
                          <a href={`${baseRealEstateUrl}/homes/location/city/tampa-fl`} target="_blank" rel="noreferrer noopener">Tampa, FL</a>,&nbsp;
                          <a href={`${baseRealEstateUrl}/homes/location/city/tallahassee-fl`} target="_blank" rel="noreferrer noopener">Tallahassee, FL</a>,&nbsp;
                          <a href={`${baseRealEstateUrl}/homes/location/city/jacksonville-fl`} target="_blank" rel="noreferrer noopener">Jacksonville, FL</a>,&nbsp;
                          <a href={`${baseRealEstateUrl}/homes/location/city/naples-fl`} target="_blank" rel="noreferrer noopener">Naples, FL</a>,&nbsp;
                          <a href={`${baseRealEstateUrl}/homes/location/city/fort-myers-fl`} target="_blank" rel="noreferrer noopener">Fort Myers, FL</a>,&nbsp;
                          <a href={`${baseRealEstateUrl}/homes/location/city/florida-city-fl`} target="_blank" rel="noreferrer noopener">Florida City, FL</a>,&nbsp;
                          <a href={`${baseRealEstateUrl}/homes/location/city/fort-lauderdale-fl`} target="_blank" rel="noreferrer noopener">Fort Lauderdale, FL</a>,&nbsp;
                          <a href={`${baseRealEstateUrl}/homes/location/city/sarasota-fl`} target="_blank" rel="noreferrer noopener">Sarasota, FL</a>,&nbsp;
                          <a href={`${baseRealEstateUrl}/homes/location/city/destin-fl`} target="_blank" rel="noreferrer noopener">Destin, FL</a>,&nbsp;
                          <a href={`${baseRealEstateUrl}/homes/location/city/st-petersburg-fl`} target="_blank" rel="noreferrer noopener">St. Petersburg, FL</a>,&nbsp;
                          <a href={`${baseRealEstateUrl}/homes/location/city/pensacola-fl`} target="_blank" rel="noreferrer noopener">Pensacola, FL</a>,&nbsp;
                          <a href={`${baseRealEstateUrl}/homes/location/city/st-augustine-fl`} target="_blank" rel="noreferrer noopener">St. Augustine, FL</a>,&nbsp;
                          <a href={`${baseRealEstateUrl}/homes/location/city/gainesville-fl`} target="_blank" rel="noreferrer noopener">Gainesville, FL</a>,&nbsp;
                          <a href={`${baseRealEstateUrl}/homes/location/city/cape-coral-fl`} target="_blank" rel="noreferrer noopener">Cape Coral, FL</a>,&nbsp;
                          <a href={`${baseRealEstateUrl}/homes/location/city/west-palm-beach-fl`} target="_blank" rel="noreferrer noopener">West Palm Beach, FL</a>,&nbsp;
                          <a href={`${baseRealEstateUrl}/homes/location/city/clearwater-fl`} target="_blank" rel="noreferrer noopener">Clearwater, FL</a>,&nbsp;
                          <a href={`${baseRealEstateUrl}/homes/location/city/marco-island-fl`} target="_blank" rel="noreferrer noopener">Marco Island, FL</a>,&nbsp;
                          <a href={`${baseRealEstateUrl}/homes/location/city/boca-raton-fl`} target="_blank" rel="noreferrer noopener">Boca Raton, FL</a>,&nbsp;
                          <a href={`${baseRealEstateUrl}/homes/location/city/miami-beach-fl`} target="_blank" rel="noreferrer noopener">Miami Beach, FL</a>,&nbsp;
                          <a href={`${baseRealEstateUrl}/homes/location/city/daytona-beach-fl`} target="_blank" rel="noreferrer noopener">Daytona Beach, FL</a>,&nbsp;
                          <a href={`${baseRealEstateUrl}/homes/location/city/kissimmee-fl`} target="_blank" rel="noreferrer noopener">Kissimmee, FL</a>.&nbsp;
                        </p>

                        <p>
                          {"Our mortgage professionals (licensed loan officers and home loan consultants) in " + props.custom.stateLongName + " are mortgage experts trained to guide you through the complicated loan underwriting process so you can close on time with Zero hassles. CapCenter offers conventional, HomeReady®, Home Possible, Jumbo, VA, FHA, and adjustable rate mortgage loan products."}
                        </p>

                        <p>
                          CapCenter specializes in no-fee and low-fee mortgages with low interest rates.
                          We may initially seem like we don't offer the best rates in the market, but many lenders charge additional fees for lower interest rates in the form of points and lender and non-lender closing costs. If you're looking for the lowest rate, try applying expected closing costs to pay down discount points with CapCenter. In an apples to apples comparison, <strong>we offer some of the best rates in the market and do not simply add closing costs into the loan balance</strong>. We are always striving to offer the best overall package for each of our clients' unique needs.
                          We encourage borrowers to not only look at interest rates and APR but also non-lender fees and terms when comparing loan estimates.
                          CapCenter helps borrowers get around closing costs by eliminating fees for borrowers for many popular home loan products.
                          Many of our most popular home loan products have <strong>no closing costs</strong> or <strong>zero closing costs</strong> mortgages, which are often the best mortgage options for <strong>first-time home buyers</strong> and for anyone that may sell or refinance before the loan term (commonly 30 years) because these options allow for more funds to be allocated to the down payment and these options also have less sunk costs associated with paying off the loan on sale of the property or refinancing the loan if interest rates drop.
                          Some of our products, such as the VA home loan for veterans, have <strong>zero down payment</strong> options for certain borrowers and conditions, such as borrowers with service-connected disabilities and appraisal value.
                          Another set of products, such as <a href="https://faq.capcenter.com/article/74-does-capcenter-offer-homeready-and-home-possible-products" target="_blank" rel="noreferrer noopener">HomeReady® and Home Possible</a>, have <strong>low down payment</strong> options for certain borrowers and conditions, such as first-time home buyers and income limits.
                          Our loan consultants can guide you through our loan products to find the best fit loan for your specific situation before and after you apply. We're dedicated to provide you fast and reliable services with our refined operational procedures. It'll feel like we're waiving closing costs, and the most frequently asked question after receiving a free quote is, "what's the catch?" That's our secret sauce, but we assure you that there is no catch and 95% of our past clients would recommend our services to friends and family.
                          In fact, we encourage you to shop around and compare loan estimates (it helps to compare rates, points, terms, mortgage insurance, lender closing costs, and non-lender closing costs as well) and any realty credits. Once we've gain your trust, we're here to help you purchase all your future homes, saving you time and money, over and over again.
                        </p>

                        <p>
                          {props.custom.isRealty ?
                            (<><p><a href={getUrlWithUtmQueryString(`${baseRealtyUrl}/find-best-local-realtor`)} className={'d-flex btn-primary btn-sm'}>Find our best REALTORS® near {props.custom.stateLongName}</a></p><p><a href={getUrlWithUtmQueryString(`${baseRealtyUrl}/forms/request-realty`)} className={'d-flex btn-primary btn-sm'}>Schedule a consultation with a top-rated REALTOR® near {props.custom.stateLongName}</a></p></>) : ""}
                          {props.custom.isMortgage ?
                            (<a href={getUrlWithUtmQueryString(`${baseUrl}/apply-now/`)} className={'d-flex btn-primary btn-sm'}>Apply now for a mortgage in {props.custom.stateLongName}</a>) : ""}
                        </p>

                        <p>
                          <a href={getUrlWithUtmQueryString(`${baseUrl}/mortgage-rates/florida`)} className={'d-flex btn-primary btn-sm'}>View our best mortgage interest rates today in {props.custom.stateLongName}</a>
                        </p>

                        <p>
                          <a href={getUrlWithUtmQueryString(`${baseUrl}/mortgage-calculator/purchase`)} className={'d-flex btn-primary btn-sm'}>Get a free, anonymous quote calculated to compare mortgage rates and closing costs in {props.custom.stateLongName}</a>
                        </p>

                        <p>&nbsp;</p>
                      </div>

                      <div className="col-12 col-md-4 mb-4">
                        <img src={ImageGlenAllenOffice} alt={'CapCenter HQ best mortgage home loan in Florida serviced by Virginia lending company low fee zero closing cost'} />
                      </div>

                      <div className="col-12 image-gallery">
                        <img src={ImageGlenAllenVA} alt={props.custom.title + " best mortgage home loan in Florida serviced by Virginia lender company low fee zero closing cost"} />
                        <img src={ImageRichmondRaceway} alt={props.custom.title + " RVA Richmond Raceway best mortgage home loan in Florida serviced by Virginia lender company low fee zero closing cost"} />
                        <img src={ImageGlenAllenVA2} alt={props.custom.title + " best mortgage home loan in Florida serviced by Virginia lender company low fee zero closing cost"} />
                        <img src={ImageGlenAllenVAPieDay} alt={props.custom.title + " RVA Richmond Glen Allen VA Pie Day 1 best mortgage home loan lender in Florida serviced by Virginia company low fee zero closing cost"} />
                        <img src={ImageGlenAllenVAPieDay2} alt={props.custom.title + " RVA Richmond Glen Allen VA Pie Day 2 best mortgage home lender in Florida serviced by Virginia company low fee zero closing cost"} />
                        <img src={ImageGlenAllenVAPieDay3} alt={props.custom.title + " RVA Richmond Glen Allen VA Pie Day 3 best mortgage home lender in Florida serviced by Virginia company low fee zero closing cost"} />
                        <img src={ImageGlenAllenVAPieDay4} alt={props.custom.title + " RVA Richmond Glen Allen VA Pie Day 4 best mortgage home lender in Florida serviced by Virginia company low fee zero closing cost"} />
                        <img src={ImageGlenAllenVAHalloweenTeam} alt={props.custom.title + " RVA Richmond Glen Allen VA in Florida serviced by Virginia Halloween Winning Team best mortgage home loan lender company in Virginia"} />
                        <img src={ImageGlenAllenVAHalloween} alt={props.custom.title + " Halloween best mortgage home loan lender company in Florida serviced by Virginia"} />
                        <img src={ImageSmores} alt={props.custom.title + " S'mores Day best mortgage home loan lender company in Florida serviced by Virginia low fee zero closing cost"} />
                        <img src={ImageSmores2} alt={props.custom.title + " S'mores Day best mortgage home loan lender company in Florida serviced by Virginia low fee zero closing cost"} />
                      </div>
                    </div>
                  </section>

                  <section className={(props.custom.code)}>
                    <div className="row">
                      <div className="col-12">
                        <img src={ImageCapCenterHQ} alt={props.custom.title + " best mortgage home loan in Florida serviced by Virginia lender high quality low fee zero closing costs"} width={'500px'}/>
                      </div>
                    </div>
                  </section>

                  <section className={(props.custom.code)}>
                    <div className="row">
                      <div className="col-12">
                        <h4>
                          <a href={`${baseRealEstateUrl}/homes/location/state/florida`} target="_blank" rel="noreferrer noopener">
                          Homes for Sale in {props.custom.stateLongName}
                          </a>
                        </h4>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-12">
                        <ol>
                          {renderedHtmlListings}
                        </ol>
                      </div>
                    </div>
                  </section>

                </article>
              </main>
            </div>
          </>
        </AppWrapper>
      )}
    </React.Fragment>
  );
}

export default State;
